import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { AuthState, useAuth } from '@furality/frontend-stack';
import Assets from '@/components/_accounts/Assets.tsx';
import Connections from '@/components/_accounts/Connections.tsx';
import Coupon from '@/components/_accounts/Coupon.tsx';
import Rewards from '@/components/_accounts/Rewards.tsx';
import ErrorDisplay, { PortalLoginErrorContent } from '@/components/ErrorDisplay.tsx';
import { CardLayout } from '@/components/layouts/index.tsx';
import InlineLoader from '@/components/loading/InlineLoader.tsx';

const Accounts = () => {
  const auth = useAuth();
  const { t } = useTranslation(['common', 'accounts']);

  useEffect(() => {
    if (auth.state === AuthState.NotLoggedIn) {
      auth.login();
    }
  }, [auth]);

  return (
    <div className="my-2 my-lg-4 text-center">
      <h1>{t('shared.navigation.accounts')}</h1>
      {(auth.state === AuthState.NotLoggedIn || auth.state === AuthState.Loading) && (
        <InlineLoader />
      )}
      {auth.state === AuthState.Error && (
        <div className="text-left">
          <ErrorDisplay title={t('shared.login_error.title')} error={auth.error}>
            <PortalLoginErrorContent />
          </ErrorDisplay>
        </div>
      )}
      {auth.state === AuthState.LoggedIn && (
        <>
          <p>
            {auth.user.name} -{' '}
            <button
              type="button"
              className="subtle-button text-underline"
              onClick={() => auth.logout()}
            >
              {t('accounts:not_you')}
            </button>
          </p>
          <Connections />
          <Coupon />
          <Rewards />
          <Assets />
        </>
      )}
    </div>
  );
};

export const Route = createFileRoute('/accounts')({
  component: () => (
    <CardLayout title="shared.navigation.accounts">
      <Accounts />
    </CardLayout>
  ),
});
